module.exports = __webpack_public_path__ + "img/icon_connect_white.4b047280.svg";